/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h1[_ngcontent-%COMP%]{margin-top:120px;margin-bottom:40px}h1[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/error-404/error-404.component.scss.shim.ngstyle.js.pre-build-optimizer.js